// Exports
export default {
	"CameraButton": "CameraButton_kttfg",
	"BadgeError": "BadgeError_NdOZU"
};
